import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { tenant } from '../../tenants';
Vue.use(Vuetify);

// @ts-ignore
export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: tenant.branding.colors.primary,
                secondary: '#424242',
                accent: '#82B1FF',
                error: '#FF5252',
                info: tenant.branding.colors.info,
                success: '#4CAF50',
                warning: '#ff993f'
            }
        }
    },
    icons: {
        iconfont: 'md'
    }
});
